<template>
    <div class="row justify-content-center">
        <UserDetails :group-code="groupCode" class="col-xl-8"/>
    </div>
</template>
<script>
import UserDetails from '../../components/users/UserDetails';
import store from '../../store/store';

export default {
  components: {
    UserDetails,
  },
  computed: {
    groupCode() {
      return this.$route.params.groupCode;
    },
  },
  beforeRouteLeave: (to, from, next) => {
    store.commit('users/userId', null);
    next();
  },
};
</script>
